import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/gerados/$documentoId',
)({
  component: function DocumentoGeradoLayout() {
    return <Outlet />
  },
})
